<template>
  <RetailerConfirmationComponent
    :title="title"
    :showAdditionalText="showAdditionalText"
    :additionalText="additionalText"
    :showIfHasAppointment="true" />
</template>

<script lang="ts">
import SelectedTimeSlot from '@/models/date-picker/SelectedTimeSlot';
import {
  Vue, Component, Prop
} from 'vue-property-decorator';
import RetailerConfirmationComponent from '../enquiry/RetailerConfirmationComponent.vue';

@Component({
  components: {
  RetailerConfirmationComponent
  }
  })
export default class TestDriveBookingConfirmationComponent extends Vue {
  @Prop({ default: 'Your Appointment' })
  public title!: string;

  @Prop({ default: false })
  public showAdditionalText!: boolean;

  @Prop({ default: 'We\'ll send an email to confirm your request.<br />manufacturerName will be in touch directly with further details.' })
  public additionalText!: string;
}
</script>
